const searchUrl = 'https://hcwsd.nl/search/';

'use strict'; // enforce stricter parsing and error handling

/**
 * Websearch
 * @author Ruben Aarts, Jesse de Vries
 */
function Sitesearch(options) {
    this.Init(options);
}

/**
 * Constructor
 * @Param object options
 * @return void
 */
Sitesearch.prototype = {
    // Initialize Object variables
    Init: function (options) { // Initialization

        // Default selectors
        const defaultOptions = {
            forms: '.tmo-search'
        }

        // Merge default options with provided options
        this.options = Object.assign({}, defaultOptions, options);

        // Initialize Prototype variables
        this.forms = document.querySelectorAll(this.options.forms);

        // Initialize Start function
        this.Start();
    },

    /**
     * Start
     * @return void
     */
    // Executes on page load
    Start: function () { // Starting functionality

        const _this = this; // Put the current context of 'this' in a variable, so we can always pass it to the next function

        // Create local variables from the Object context
        const forms = this.forms;

        function onLoadHandler() {
            _this.SetEvents(forms);
        }

        if (document.readyState === 'complete') {
            // If the document is already loaded, execute immediately
            onLoadHandler();
        } else {
            // Otherwise, add a listener for the 'load' event
            window.addEventListener('load', onLoadHandler);
        }
    },

    /**
     * SetEvents
     * @return void
     */
    // Event Handling
    SetEvents: function (forms) {

        const _this = this; // Put the current context of 'this' in a variable, so we can always pass it to the next function

        forms.forEach(function (form) { // Iterate through all search forms

            const searchUrl = 'https://maesnotarissen.nl/search/';
            let searchInputField = document.getElementById('search-input');

            const searchInputKeyUp = (execFunction, delay) => {
                let timer;
                return function () {
                    clearTimeout(timer);

                    timer = setTimeout(() => {
                        execFunction();
                    }, delay);
                };
            };

            searchInputField.addEventListener('keyup', searchInputKeyUp(getSearchResultsData, 1000));

            function getSearchResultsData()
            {
                let searchInput = searchInputField.value;

                document.getElementById('search-results').innerHTML = '';

                if (searchInput !== '') {
                    let req = new XMLHttpRequest();
                    console.log(req);
                    req.open('GET', searchUrl + searchInput + '?limit=20', true);
                    req.onload = function () {
                        if (this.status == 200) {
                            if (typeof this.response != "undefined") {
                                let results = JSON.parse(this.response);
                                for (let i = 0; i < results.length; i++) {
                                    if (typeof results[i].page_decription != 'string') {
                                        results[i].page_decription = '';
                                    }
                                    if (results[i].page_url !== '') {

                                        document.getElementById('search-results').innerHTML += `
                              <li role="option"><a href="` + results[i].page_url + `" tabindex="-1" class="dropdown__item tmo-search__result" aria-selected="false">
                                <div class="tmo-search__content">
                                    <p class="tmo-search__title"><bdi>` + results[i].page_title + `</bdi></p>
                                    <p class="tmo-search__highlight"><bdi>` + results[i].page_decription + `</bdi></p>
                                </div>
                            </a></li>
                            `;
                                    }
                                }
                            }
                        }
                    }



                    req.send();
                }
            }

        });
    },
}

export { Sitesearch };
